import { Pipe, PipeTransform } from '@angular/core';
import { Control, SelectControl } from '../models';
import { IDatiqSelect } from '@dat/datiq-components-pkg/select';
import { SelectMapper } from '../state';

@Pipe({
    name: 'controlLegacySelect',
    standalone: true,
})
export class ControlLegacySelectPipe implements PipeTransform {
    transform(value: Control, ...args: unknown[]): IDatiqSelect {
        return SelectMapper.map(value);
    }
}
